import { Popupinnhold } from '../dto/popupinnhold';
import { mountPopup } from '../components/mount-popup';
import { cookieInnenforKarantenetid } from './sjekk-cookie';

export function initPopup(monitorEndepunkt: string): void {
  const element: HTMLElement | null = document.querySelector('meta[name="popup"]');

  if (element?.dataset.content) {
    const popupinnhold = JSON.parse(element.dataset.content) as Popupinnhold;
    const popupErICookieKarantene = cookieInnenforKarantenetid(popupinnhold.popupNavn);

    if (!popupErICookieKarantene) {
      mountPopup({ innhold: popupinnhold, monitorEndepunkt });
    }
  }
}
